import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useUserRole } from "@/hooks/useUserRole";

interface SellerRouteProps {
  children: React.ReactNode;
}

export const SellerRoute = ({ children }: SellerRouteProps) => {
  const { user, loading: authLoading } = useAuth();
  const { data: role, isLoading: roleLoading } = useUserRole(user?.id);

  if (authLoading || roleLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Carregando...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (role !== "seller") {
    return <Navigate to="/area-cliente" replace />;
  }

  return <>{children}</>;
};

export default SellerRoute;
